module.exports = __webpack_public_path__ + "media/images/icon__compete-bfc9db8aa2ba35a41c6cd7d7216c3c1d.png";